function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "english_language",
  transform: "translate(-109 -255)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_294",
  x: 109,
  y: 255,
  fill: "none",
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "united-states-flag-rectangle",
  transform: "translate(109 170.725)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path_265",
  fill: "#F5F5F5",
  d: "M22.2,88.3H1.8c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v12.1c0,1,0.8,1.8,1.8,1.8c0,0,0,0,0,0h20.4 c1,0,1.8-0.8,1.8-1.8l0,0V90.1C24,89.1,23.2,88.3,22.2,88.3z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_180",
  fill: "#FF4B55",
  transform: "translate(0 88.275)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_266",
  d: "M0.1,1.2h23.8C23.6,0.5,23,0,22.2,0H1.8C1,0,0.4,0.5,0.1,1.2z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_300",
  y: 4.8,
  width: 24,
  height: 1.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_301",
  y: 2.4,
  width: 24,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_267",
  d: "M0,8.1c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0H24V7.3H0V8.1z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_302",
  y: 12.1,
  width: 24,
  height: 1.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_268",
  d: "M23.9,14.5H0.1c0.3,0.7,0.9,1.2,1.7,1.2h20.4C23,15.7,23.6,15.2,23.9,14.5z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_303",
  y: 9.7,
  width: 24,
  height: 1.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path_269",
  fill: "#41479B",
  d: "M0.4,96.7h10.3c0.2,0,0.4-0.2,0.4-0.4l0,0v-7.6c0-0.2-0.2-0.4-0.4-0.4h0h-9 c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v6.3C0,96.6,0.2,96.7,0.4,96.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_181",
  fill: "#F5F5F5",
  transform: "translate(0.668 89.198)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_270",
  d: "M0.5,0l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.7,0.5l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.5,0.7 L0.2,0.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L0,0.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L0.5,0C0.4,0,0.4,0,0.5,0C0.5,0,0.5,0,0.5,0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_271",
  d: "M0.5,1.5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.7,2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.5,2.1 L0.2,2.3c0,0,0,0-0.1,0c0,0,0,0,0,0L0.2,2L0,1.8c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L0.5,1.5C0.4,1.4,0.4,1.4,0.5,1.5 C0.5,1.4,0.5,1.5,0.5,1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_272",
  d: "M0.5,2.9l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.7,3.4l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0 L0.5,3.6L0.2,3.7c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L0,3.2c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L0.5,2.9C0.4,2.9,0.4,2.9,0.5,2.9 C0.5,2.9,0.5,2.9,0.5,2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_273",
  d: "M0.5,4.3l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.7,4.9l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.5,5 L0.2,5.2c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L0,4.7c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L0.5,4.3C0.4,4.3,0.4,4.3,0.5,4.3 C0.5,4.3,0.5,4.3,0.5,4.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_274",
  d: "M0.5,5.8L0.6,6h0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.7,6.3l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L0.5,6.4 L0.2,6.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L0,6.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L0.5,5.8C0.4,5.8,0.4,5.7,0.5,5.8 C0.5,5.8,0.5,5.8,0.5,5.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_275",
  d: "M1.6,0.7L1.7,1H2c0,0,0,0,0,0c0,0,0,0,0,0L1.8,1.2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L1.6,1.4 L1.3,1.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L1.1,1.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L1.6,0.7C1.5,0.7,1.6,0.7,1.6,0.7 C1.6,0.7,1.6,0.7,1.6,0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_276",
  d: "M1.6,2.2l0.1,0.3H2c0,0,0,0,0,0c0,0,0,0,0,0L1.8,2.7L1.9,3c0,0,0,0,0,0c0,0,0,0,0,0L1.6,2.8 L1.3,3c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L1.1,2.5c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L1.6,2.2C1.5,2.1,1.6,2.1,1.6,2.2 C1.6,2.1,1.6,2.2,1.6,2.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_277",
  d: "M1.6,3.6l0.1,0.3H2c0,0,0,0,0,0c0,0,0,0,0,0L1.8,4.1l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L1.6,4.3 L1.3,4.4c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L1.1,3.9c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L1.6,3.6C1.5,3.6,1.6,3.6,1.6,3.6 C1.6,3.6,1.6,3.6,1.6,3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_278",
  d: "M1.6,5l0.1,0.3H2c0,0,0,0,0,0c0,0,0,0,0,0L1.8,5.6l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L1.6,5.7 L1.3,5.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L1.1,5.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L1.6,5C1.5,5,1.6,5,1.6,5C1.6,5,1.6,5,1.6,5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_279",
  d: "M2.7,0l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L2.9,0.5L3,0.8c0,0,0,0,0,0c0,0,0,0,0,0L2.7,0.7 L2.5,0.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L2.2,0.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L2.7,0C2.7,0,2.7,0,2.7,0C2.7,0,2.7,0,2.7,0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_280",
  d: "M2.7,1.5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L2.9,2L3,2.3c0,0,0,0,0,0c0,0,0,0,0,0L2.7,2.1 L2.5,2.3c0,0,0,0-0.1,0c0,0,0,0,0,0L2.5,2L2.2,1.8c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L2.7,1.5C2.7,1.4,2.7,1.4,2.7,1.5 C2.7,1.4,2.7,1.5,2.7,1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_281",
  d: "M2.7,2.9l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L2.9,3.4L3,3.7c0,0,0,0,0,0c0,0,0,0,0,0L2.7,3.6 L2.5,3.7c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L2.2,3.2c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L2.7,2.9C2.7,2.9,2.7,2.9,2.7,2.9 C2.7,2.9,2.7,2.9,2.7,2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_282",
  d: "M2.7,4.3l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L2.9,4.9L3,5.1c0,0,0,0,0,0c0,0,0,0,0,0L2.7,5 L2.5,5.2c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L2.2,4.7c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L2.7,4.3C2.7,4.3,2.7,4.3,2.7,4.3 C2.7,4.3,2.7,4.3,2.7,4.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_283",
  d: "M2.7,5.8L2.8,6h0.3c0,0,0,0,0,0c0,0,0,0,0,0L2.9,6.3L3,6.6c0,0,0,0,0,0c0,0,0,0,0,0L2.7,6.4 L2.5,6.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L2.2,6.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L2.7,5.8C2.7,5.8,2.7,5.7,2.7,5.8 C2.7,5.8,2.7,5.8,2.7,5.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_284",
  d: "M3.8,0.7L3.9,1h0.3c0,0,0,0,0,0c0,0,0,0,0,0L4,1.2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L3.8,1.4 L3.6,1.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L3.4,1.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L3.8,0.7C3.8,0.7,3.8,0.7,3.8,0.7 C3.8,0.7,3.8,0.7,3.8,0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_285",
  d: "M3.8,2.2l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L4,2.7L4.1,3c0,0,0,0,0,0c0,0,0,0,0,0L3.8,2.8 L3.6,3c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L3.4,2.5c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L3.8,2.2C3.8,2.1,3.8,2.1,3.8,2.2 C3.8,2.1,3.8,2.2,3.8,2.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_286",
  d: "M3.8,3.6l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L4,4.1l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L3.8,4.3 L3.6,4.4c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L3.4,3.9c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L3.8,3.6C3.8,3.6,3.8,3.6,3.8,3.6 C3.8,3.6,3.8,3.6,3.8,3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_287",
  d: "M3.8,5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L4,5.6l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L3.8,5.7 L3.6,5.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L3.4,5.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L3.8,5C3.8,5,3.8,5,3.8,5C3.8,5,3.8,5,3.8,5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_288",
  d: "M5,0L5,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L5.1,0.5l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L4.9,0.7 L4.7,0.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L4.5,0.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L5,0C4.9,0,4.9,0,5,0C4.9,0,5,0,5,0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_289",
  d: "M5,1.5L5,1.7h0.3c0,0,0,0,0,0c0,0,0,0,0,0L5.1,2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L4.9,2.1 L4.7,2.3c0,0,0,0-0.1,0c0,0,0,0,0,0L4.7,2L4.5,1.8c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L5,1.5C4.9,1.4,4.9,1.4,5,1.5 C4.9,1.4,5,1.5,5,1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_290",
  d: "M5,2.9L5,3.2h0.3c0,0,0,0,0,0c0,0,0,0,0,0L5.1,3.4l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L4.9,3.6 L4.7,3.7c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L4.5,3.2c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L5,2.9C4.9,2.9,4.9,2.9,5,2.9 C4.9,2.9,5,2.9,5,2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_291",
  d: "M5,4.3L5,4.6h0.3c0,0,0,0,0,0c0,0,0,0,0,0L5.1,4.9l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L4.9,5 L4.7,5.2c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L4.5,4.7c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L5,4.3C4.9,4.3,4.9,4.3,5,4.3 C4.9,4.3,5,4.3,5,4.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_292",
  d: "M5,5.8L5,6h0.3c0,0,0,0,0,0c0,0,0,0,0,0L5.1,6.3l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L4.9,6.4 L4.7,6.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L4.5,6.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L5,5.8C4.9,5.8,4.9,5.7,5,5.8 C4.9,5.8,5,5.8,5,5.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_293",
  d: "M6.1,0.7L6.2,1h0.3c0,0,0,0,0,0c0,0,0,0,0,0L6.2,1.2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L6,1.4 L5.8,1.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L5.6,1.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L6.1,0.7C6,0.7,6,0.7,6.1,0.7 C6.1,0.7,6.1,0.7,6.1,0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_294",
  d: "M6.1,2.2l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L6.2,2.7L6.3,3c0,0,0,0,0,0c0,0,0,0,0,0L6,2.8 L5.8,3c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L5.6,2.5c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L6.1,2.2C6,2.1,6,2.1,6.1,2.2 C6.1,2.1,6.1,2.2,6.1,2.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_295",
  d: "M6.1,3.6l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L6.2,4.1l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L6,4.3 L5.8,4.4c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L5.6,3.9c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L6.1,3.6C6,3.6,6,3.6,6.1,3.6 C6.1,3.6,6.1,3.6,6.1,3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_296",
  d: "M6.1,5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L6.2,5.6l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L6,5.7 L5.8,5.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L5.6,5.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L6.1,5C6,5,6,5,6.1,5C6.1,5,6.1,5,6.1,5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_297",
  d: "M7.2,0l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.4,0.5l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.1,0.7 L6.9,0.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L6.7,0.4c0,0,0,0,0-0.1c0,0,0,0,0,0H7L7.2,0C7.1,0,7.1,0,7.2,0C7.2,0,7.2,0,7.2,0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_298",
  d: "M7.2,1.5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.4,2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.1,2.1 L6.9,2.3c0,0,0,0-0.1,0c0,0,0,0,0,0L6.9,2L6.7,1.8c0,0,0,0,0-0.1c0,0,0,0,0,0H7L7.2,1.5C7.1,1.4,7.1,1.4,7.2,1.5 C7.2,1.4,7.2,1.5,7.2,1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_299",
  d: "M7.2,2.9l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.4,3.4l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0 L7.1,3.6L6.9,3.7c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L6.7,3.2c0,0,0,0,0-0.1c0,0,0,0,0,0H7L7.2,2.9C7.1,2.9,7.1,2.9,7.2,2.9 C7.2,2.9,7.2,2.9,7.2,2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_300",
  d: "M7.2,4.3l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.4,4.9l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.1,5 L6.9,5.2c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L6.7,4.7c0,0,0,0,0-0.1c0,0,0,0,0,0H7L7.2,4.3C7.1,4.3,7.1,4.3,7.2,4.3 C7.2,4.3,7.2,4.3,7.2,4.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_301",
  d: "M7.2,5.8L7.3,6h0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.4,6.3l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L7.1,6.4 L6.9,6.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L6.7,6.1c0,0,0,0,0-0.1c0,0,0,0,0,0H7L7.2,5.8C7.1,5.8,7.1,5.7,7.2,5.8 C7.2,5.8,7.2,5.8,7.2,5.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_302",
  d: "M8.3,0.7L8.4,1h0.3c0,0,0,0,0,0c0,0,0,0,0,0L8.5,1.2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L8.3,1.4 L8,1.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L7.8,1.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L8.3,0.7C8.2,0.7,8.3,0.7,8.3,0.7 C8.3,0.7,8.3,0.7,8.3,0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_303",
  d: "M8.3,2.2l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L8.5,2.7L8.6,3c0,0,0,0,0,0c0,0,0,0,0,0L8.3,2.8 L8,3C8,3,8,3,8,3c0,0,0,0,0,0l0.1-0.3L7.8,2.5c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L8.3,2.2C8.2,2.1,8.3,2.1,8.3,2.2 C8.3,2.1,8.3,2.2,8.3,2.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_304",
  d: "M8.3,3.6l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L8.5,4.1l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0 L8.3,4.3L8,4.4c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L7.8,3.9c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L8.3,3.6C8.2,3.6,8.3,3.6,8.3,3.6 C8.3,3.6,8.3,3.6,8.3,3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_305",
  d: "M8.3,5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L8.5,5.6l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L8.3,5.7 L8,5.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L7.8,5.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L8.3,5C8.2,5,8.3,5,8.3,5C8.3,5,8.3,5,8.3,5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_306",
  d: "M9.4,0l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.6,0.5l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.4,0.7 L9.1,0.9c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L8.9,0.4c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L9.4,0C9.3,0,9.4,0,9.4,0C9.4,0,9.4,0,9.4,0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_307",
  d: "M9.4,1.5l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.6,2l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.4,2.1 L9.1,2.3c0,0,0,0-0.1,0c0,0,0,0,0,0L9.2,2L8.9,1.8c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L9.4,1.5C9.3,1.4,9.4,1.4,9.4,1.5 C9.4,1.4,9.4,1.5,9.4,1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_308",
  d: "M9.4,2.9l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.6,3.4l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0 L9.4,3.6L9.1,3.7c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L8.9,3.2c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L9.4,2.9C9.3,2.9,9.4,2.9,9.4,2.9 C9.4,2.9,9.4,2.9,9.4,2.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_309",
  d: "M9.4,4.3l0.1,0.3h0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.6,4.9l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.4,5 L9.1,5.2c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L8.9,4.7c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L9.4,4.3C9.3,4.3,9.4,4.3,9.4,4.3 C9.4,4.3,9.4,4.3,9.4,4.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_310",
  d: "M9.4,5.8L9.5,6h0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.6,6.3l0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0L9.4,6.4 L9.1,6.6c0,0,0,0-0.1,0c0,0,0,0,0,0l0.1-0.3L8.9,6.1c0,0,0,0,0-0.1c0,0,0,0,0,0h0.3L9.4,5.8C9.3,5.8,9.4,5.7,9.4,5.8 C9.4,5.8,9.4,5.8,9.4,5.8z"
}))));

function SvgEnglishLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishLanguage);
export default __webpack_public_path__ + "static/media/english_language.ae492c39.svg";
export { ForwardRef as ReactComponent };